module.exports = __webpack_public_path__ + "static/logo-incorporadora-176cd039aefb4cc8dc6c68e5cb3c2783.png";